import React, { useRef, useEffect } from "react";
import { useTheme } from "../../context-v2/ThemeContext";
import "../../styles-v2/dropdown/v2-theme-dropdown.css";

const ThemeDropdown = ({ isOpen, onClose }) => {
  const { themeMode, setTheme } = useTheme();
  const dropdownRef = useRef(null);

  const themeOptions = [
    {
      id: "light",
      label: "Light",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="5"></circle>
          <line x1="12" y1="1" x2="12" y2="3"></line>
          <line x1="12" y1="21" x2="12" y2="23"></line>
          <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
          <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
          <line x1="1" y1="12" x2="3" y2="12"></line>
          <line x1="21" y1="12" x2="23" y2="12"></line>
          <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
          <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
      ),
    },
    {
      id: "dark",
      label: "Dark",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
      ),
    },
    {
      id: "system",
      label: "System",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
      ),
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleThemeSelect = (themeId) => {
    setTheme(themeId);
    onClose();
  };

  return (
    <div className="v2-theme-dropdown" ref={dropdownRef}>
      {themeOptions.map((option) => (
        <button
          key={option.id}
          className={`v2-theme-dropdown__item ${
            themeMode === option.id ? "v2-theme-dropdown__item--active" : ""
          }`}
          onClick={() => handleThemeSelect(option.id)}
        >
          <span className="v2-theme-dropdown__icon">{option.icon}</span>
          <span className="v2-theme-dropdown__label">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ThemeDropdown;
